import React, { useState } from "react";
import ChatHeader from "../components/ChatHeader";
import ChatConversation from "../components/ChatConversation";
import ChatInput from "../components/ChatInput";

import consiness from "../images/consiness-Logo.png";

// router
import { useRouter } from "../routers/hooks/use-router";

// auth context
import { useAuth } from "../auth/auth-provider";

// chat context
import { useChat } from "../auth/chat-provider";

// api
import { initializeChatbot } from "../api/chatBot";

// helpers
import { getInLocalStorage, setInLocalStorage } from "../api/helpers";

const backgroundStyle = {
  backgroundImage: `url(${consiness})`,
  backgroundSize: "contain",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  opacity: 0.2,
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  width: "100%",
  height: "100%",
  zIndex: -1,
};

export default function Chat() {
  const router = useRouter();

  const sChatID = getInLocalStorage("chat_id");

  const { emptyChat, addMessage, resetChat } = useChat();

  const [selectedModel, setSelectedModel] = useState("qwen2.5:32b");

  const [botIsLoading, setBotIsLoading] = useState(false);

  // auth context
  const { logout } = useAuth();

  const addNewChat = async () => {
    const response = await initializeChatbot();

    if (!response.foundEmptyChat) {
      resetChat();
      addMessage(response.message, "bot");

      setInLocalStorage("chat_id", response.bot_id);

      router.push(`/chat/`);
    }
  };

  return (
    <div className="d-flex flex-column" style={{ height: "100vh" }}>
      <div style={backgroundStyle}></div>
      <div>
        <ChatHeader
          onLogout={logout}
          emptyChat={emptyChat}
          addNewChat={addNewChat}
          botIsLoading={botIsLoading}
        />
      </div>
      <div className="d-flex flex-grow-1">
        <div
          className="d-flex flex-column flex-grow-1"
          style={{
            height: "calc(100vh - 65px)",
            width: "100%",
          }}
        >
          <ChatConversation botIsLoading={botIsLoading} />
          <ChatInput
            addMessage={addMessage}
            sCurrentChatID={sChatID}
            setBotIsLoading={setBotIsLoading}
            botIsLoading={botIsLoading}
            model={selectedModel}
          />
        </div>
      </div>
    </div>
  );
}
